module.exports = __webpack_public_path__ + "img/swiper2.c1839d1f.png";